export class ListItem {

    openRemoveModal() {
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/abstract-plugins/list/list-item.ts